import { io } from "socket.io-client";

const socketUrl = process.env.NODE_ENV === "development"
    ? "http://localhost:3100"
    : "https://fotos.api.aitorleria.com";

export const socket = io(socketUrl);